export const trBrowseCategories = {
	DE: 'Durchsuchen Sie unsere Kategorien',
	EN: 'Browse our categories',
	FR: 'Parcourir nos catégories',
};
